import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import translate from "./../services/translation.json";
import "./../assets/scss/services.scss";
import technologiesLogos from "./../assets/images/technologies";
import servicesBanner from "./../assets/images/services-banner.png";
import ServicesTabs from "../components/servicesTabs/servicesTabs";

const Services = ({ lang }) => {
  const location = useLocation();
  const initialServiceId = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("service") || "";
  }, [location.search]);

  const renderTechnologiesSection = () => (
    <div className="technologies">
      <h1 className="blue center title">
        {translate[lang].services.technologies.title}
      </h1>
      <div className="technologies-list padded-container">
        {technologiesLogos.map((logo) => (
          <div key={logo.name} className="tech-logo">
            <img src={logo.src} alt={logo.name} />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="page-container contain services">
      <div
        className="homepage-banner"
        style={{ backgroundImage: `url(${servicesBanner})` }}
      />
      <section id="service-detail" className="services-tabs-section">
        <ServicesTabs lang={lang} initialServiceId={initialServiceId} />
      </section>
      {renderTechnologiesSection()}
      <div className="services-content">
        <h1 className="blue center title">
          {translate[lang].services.content.title}
        </h1>
        <p className="center">
          {translate[lang].services.content.description}
        </p>
      </div>
    </div>
  );
};

export default Services;
